// extracted by mini-css-extract-plugin
export var divider = "_wm-0";